import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllLocations } from "../../redux/location/actions";
import app_api from "../../utilities/api";
import { toast } from "react-hot-toast";

const LocationSelector = ({ className = "" }) => {
  const { user } = useSelector((state) => state.auth);
  const { list: locationList } = useSelector((state) => state.location);
  const dispatch = useDispatch();
  const [selectedCenterId, setSelectedCenterId] = useState(user?.centerId || "all");
  const [showReloadButton, setShowReloadButton] = useState(false);
  const timeoutRef = useRef(null);

  const fetchUser = async () => {
    if (!user?.id) return;
    try {
      const response = await app_api.get(`/api/auth/${user.id}`);
      setSelectedCenterId(response.data.data.centerId || "all");
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };

  const handleCenterChange = async (event) => {
    const centerId = event.target.value;
    setSelectedCenterId(centerId);

    try {
      await app_api.put(`/api/auth/${user.id}/center`, {
        centerId: centerId,
      });
      toast.success("Center updated successfully");
      // Show reload button
      setShowReloadButton(true);
      // Clear existing timeout if any
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      // Auto-hide after 15 seconds
      timeoutRef.current = setTimeout(() => {
        setShowReloadButton(false);
      }, 15000);
    } catch (error) {
      toast.error("Error updating center");
    }
  };

  const handleReload = () => {
    window.location.reload();
  };

  useEffect(() => {
    dispatch(getAllLocations());
    if (user?.id) {
      fetchUser();
    }
  }, [user?.id, dispatch]);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  // Don't show for THERAPIST role
  if (user?.role === "THERAPIST") {
    return null;
  }

  const selectClassName = className
    ? `block w-full rounded-md border-[1px] p-2 border-gray-300 shadow-sm focus:border-[1px] focus:border-indigo-500 text-sm ${className}`
    : "block w-full max-w-lg rounded-md border-[1px] p-2 border-gray-300 shadow-sm focus:border-[1px] focus:border-indigo-500 sm:max-w-xs sm:text-sm";

  return (
    <>
      <div>
        <select
          id="location_id"
          name="location_id"
          value={selectedCenterId}
          onChange={handleCenterChange}
          className={selectClassName}
        >
          <option value="all">Select a Location</option>
          {locationList.map((d, idx) => (
            <option key={idx} value={d.id}>
              {d.name}
            </option>
          ))}
        </select>
      </div>
      {showReloadButton && (
        <button
          onClick={handleReload}
          className="fixed top-6 left-1/2 transform -translate-x-1/2 z-50 border-2 border-indigo-600 text-indigo-600 bg-transparent hover:bg-indigo-50 font-semibold py-3 px-6 rounded-full shadow-lg transition-all duration-300 ease-in-out hover:shadow-xl animate-pulse"
          style={{
            animation: showReloadButton ? "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite" : "none",
          }}
        >
          Reload the page
        </button>
      )}
    </>
  );
};

export default LocationSelector;

